import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const WhitepapersCarousel = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  max-width: 100vw;
  scroll-snap-type: x proximity;
  & > * {
    scroll-snap-align: center;
  }
`;

export const WhitepaperContainer = styled.div`
  padding-top: 180px;
  min-width: 100vw;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 72px;
  @media (min-width: 1000px) {
    padding: 0 96px;
  }
  @media (min-width: 310px) {
    padding-top: 160px;
  }
  @media (min-width: 385px) {
    padding-top: 140px;
  }
  @media (min-width: 660px) {
    padding-top: 130px;
  }
  margin-bottom: 130px;
  @media (min-width: 1000px) {
    margin-bottom: 210px;
  }
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    @media (min-width: 880px) {
      flex-direction: row;
      justify-content: space-between;
      gap: 24px;
      padding-top: 50px;
    }
  }
`;

export const LeftColumn = styled.div`
  @media (min-width: 880px) {
    max-width: 380px;
  }
  @media (min-width: 1000px) {
    max-width: 456px;
  }
`;

export const Title = styled.h1`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  margin-bottom: 30px;
  @media (min-width: 1000px) {
    font-size: 56px;
    letter-spacing: -1px;
    line-height: 64px;
    margin-bottom: 40px;
  }
`;

export const Text = styled.p`
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 24px;
`;

export const TextBlue = styled.p`
  box-sizing: border-box;
  color: var(--blue);
  font-family: Rubik;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 30px;
  @media (min-width: 1000px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const TextBlue2 = styled.p`
  box-sizing: border-box;
  color: var(--blue);
  font-family: Rubik;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 30px;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  @media (min-width: 880px) {
    max-width: 400px;
  }
  & > img {
    height: auto;
    width: 100%;
    object-fit: cover;
    object-position: 50% 88%;
  }
  @media (min-width: 880px) {
    & > img {
      width: 400px;
      height: 200px;
    }
  }
  @media (min-width: 1000px) {
    & > img {
      height: auto;
    }
  }
`;

const ArrowButton = styled(Link)`
  position: absolute;
  top: 400px;
  color: var(--blue);
  outline: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 16px;
  font-size: 32px;
  @media (min-width: 1000px) {
    padding: 0 8px;
    font-size: 48px;
  }
`;

export const LeftButton = styled(ArrowButton)`
  left: 0;
  transform: translateX(-100%);
`;

export const RightButton = styled(ArrowButton)`
  right: 0;
  transform: translateX(100%);
`;
